export default __webpack_public_path__ + "static/SONY_IMX335_Night-1480755db621636cd23da7bbb26ccbbb.webp";